import { useEffect } from 'react';
import { useNavigate, Outlet } from 'react-router-dom'; // Import Outlet for nested routes
import Sidebar from '../components/Dashboard/Sidebar';
import { useAuthContext } from '../contexts/AuthContext';
import Topbar from '../components/Dashboard/Topbar';

const Dashboard = () => {
    const { user } = useAuthContext();
    const navigate = useNavigate(); // Initialize navigation

    useEffect(() => {
        if (!user) {
            // Redirect to the home page if the user is not authenticated
            navigate('/');
        }
    }, [user, navigate]);

    if (!user) {
        // Optionally, render a loading or fallback UI while redirecting
        return <div>Redirecting...</div>;
    }

    return (
        <div id="dashboardLayout" className="fixed inset-0 flex">
            <Sidebar />
            <div className="flex-1 flex flex-col">
                <Topbar/>
                <main id="dashboardContent" className="flex-1 overflow-y-auto bg-gray-50 p-6 dashboard-content">
                    <Outlet /> {/* Render the nested routes here */}
                </main>
            </div>
        </div>
    );
};

export default Dashboard;